<template>
	<div>
		<div class="colhead">
			<h2 class="header_h2">订单管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="订单名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>

		</el-header>
		<el-main>

			<el-table border ref="multipleTable" tooltip-effect="dark"
				:data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="OrderName" label="订单名称" width="300px"></el-table-column>
				<el-table-column prop="CreateDate" label="创建时间"></el-table-column>
				<el-table-column prop="SalerName" label="创建人"></el-table-column>

				<el-table-column prop="OrderState" label="状态">
					<template slot-scope="scope">
						<div v-for="item in OrderStates">
							<label v-if='scope.row.OrderState==item.value'>{{item.key}}</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="Memo" label="备注"></el-table-column>
				<el-table-column label="操作" width="400px" fixed="right">
					<template slot-scope="scope">
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text"
							size="small">编辑</el-button>
						<el-button @click="BookManage(scope.$index, scope.row)" icon="el-icon-circle-close"
							type="text" size="small">预约查询</el-button>
						<el-button @click="ItemMamage(scope.$index, scope.row)" icon="el-icon-edit" type="text"
							size="small">项目管理</el-button>
						<el-button @click="CusMamage(scope.$index, scope.row)" icon="el-icon-edit" type="text"
							size="small">人员管理</el-button>
						<el-popover :ref="'popover'+scope.$index" placement="right" width="400" trigger="click">
							<el-row type="flex" justify="center">
								<el-table width='400px' :ref="'bookbranchdt'+scope.$index" :data="allbranch"
									tooltip-effect="dark" @selection-change="handleSelectionChange" style="width: 100%">
									<el-table-column type="selection" label="" width="55">
									</el-table-column>
									<el-table-column prop="branch_name" label="全选/全不选" width="320">

									</el-table-column>
								</el-table>
							</el-row>
							<div style="text-align: right; margin: 0">
								<el-button size="mini" type="text" @click.native="branchCancel(scope)">取消</el-button>
								<el-button type="primary" size="mini" @click.native="branchSure(scope)">确定</el-button>
							</div>
							<el-button slot="reference" @click.native="SetBookBranch(scope)" icon="el-icon-edit"
								type="text" size="small">预约分院管理</el-button>
						</el-popover>
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-sizes="[5, 10, 20, 40]" :page-size="pagesize"
							layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>
		<!-- 修改信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="订单名称">
					<el-input v-model="EditInfo.OrderName"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="EditInfo.Memo"></el-input>
				</el-form-item>

				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

		<!-- ----新增信息---- -->
		<el-dialog title="新增信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<el-form-item label="订单名称">
					<el-input v-model="AddInfo.OrderName"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="AddInfo.Memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- </el-main> -->
	</div>
</template>



<script>
	import enums from '../../commontools/enums.js'
	import order from '../../apifunction/Order.js'
	import Branch from '../../apifunction/Branch.js'
	export default {
		created() {
			this.GetOrderList();
			this.getAllBranch();
		},
		data() {
			return {
				selorderid: '',
				isIndeterminate: true,
				checkAll: false,
				allbranch: [],
				// allshowbranch:[],
				selbranch: [],
				OrderList: [],
				OrderStates: enums.OrderState,
				currentPage: 1,
				pagesize: 10,
				bao1edit: false,
				bao1newadd: false,
				showbookbranch: false,
				idx: null,
				//   通过姓名查询
				select_word: "",
				EditInfo: {
					OrderID: '',
					OrderName: '',
					CreateDate: '',
					SalerID: '',
					SalerName: '',
					Memo: '',
					CommitDate: '',
					ApproveDate: '',
					CommitCorpID: '',
					ApproveName: '',
					ApproveID: '',
					ApproveMemo: '',
					OrderState: '0'
				},
				AddInfo: {
					OrderID: '',
					OrderName: '',
					CreateDate: '',
					SalerID: '',
					SalerName: '',
					Memo: '',
					CommitDate: '',
					ApproveDate: '',
					CommitCorpID: '',
					ApproveName: '',
					ApproveID: '',
					ApproveMemo: '',
					OrderState: '0'
				}
			};
		},
		methods: {
			SetBookBranch(scope) {
				this.selorderid = scope.row.OrderID;
				this.getSelBranch(scope.$index);
			},
			branchCancel(scope) {
				scope._self.$refs['popover' + scope.$index].doClose()
			},
			branchSure(scope) {
				let sel = [];
				if (this.selbranch.length > 0)
					for (let i = 0; i < this.selbranch.length; i++) {
						let temp = {
							orderid: this.selorderid,
							branchid: this.selbranch[i].branch_id
						};
						sel.push(temp);

					}
				order.SaveOrderBookBranch(this.selorderid, JSON.stringify(sel))
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.showbookbranch = false;
							this.$message.success('保存成功！');
							scope._self.$refs['popover' + scope.$index].doClose()
						} else
							this.$message.info(ent.Msg);
					})
			},
			handleSelectionChange(val) {

				this.selbranch = val;
			},
			getAllBranch() {
				let user = this.$myglobal.getUserInfo();
				Branch.GetBranchByCorpID(user.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.allbranch = JSON.parse(ent.Data);
							}
						} else
							this.$message.info(ent.Msg);
					})
			},
			getSelBranch(index) {
				Branch.GetBranchByOrderID(this.selorderid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {

								let list = JSON.parse(ent.Data);
								this.toggleSelection(list, index)
								this.selbranch = list;

							}
						} else
							this.$message.info(ent.Msg);

					})
			},
			toggleSelection(rows, index) {
				this.$nextTick(() => {
					this.allbranch.forEach(row => {
						let ent = rows.find(item => {
							return row.branch_id == item.branch_id;
						});
						if (ent)
							this.$refs['bookbranchdt' + index].toggleRowSelection(row, true);
						else
							this.$refs['bookbranchdt' + index].toggleRowSelection(row, false);
					});
				})
			},

			//   得到所有的数据---------------
			GetOrderList() {
				order.GetMyOrder(this.$myglobal.getUserInfo().id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null')
								this.OrderList = JSON.parse(ent.Data);

						} else
							this.$message.info(ent.Msg);
					})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;

				this.EditInfo = {
					OrderID: row.OrderID,
					OrderName: row.OrderName,
					CreateDate: row.CreateDate,
					SalerID: row.SalerID,
					SalerName: row.SalerName,
					Memo: row.Memo,
					CommitDate: row.CommitDate,
					ApproveDate: row.ApproveDate,
					CommitCorpID: row.CommitCorpID,
					ApproveName: row.ApproveName,
					ApproveID: row.ApproveID,
					ApproveMemo: row.ApproveMemo,
					OrderState: row.OrderState,
				};
			},
			ItemMamage(index, row) {

				var data = {
					path: '/ordergroup',
					query: {
						ent: JSON.stringify(row)
					}
				};
				this.$router.push(data)
			},
			CusMamage(index, row) {

				var data = {
					path: '/ordercus',
					query: {
						ent: JSON.stringify(row)
					}
				};
				this.$router.push(data)
			},
			BookManage(index, row) {
			
				var data = {
					path: '/orderbookdetail',
					query: {
						ent: JSON.stringify(row)
					}
				};
				this.$router.push(data)
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				order.EditOrder(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.OrderList.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.OrderID = '';
				this.AddInfo.OrderName = '';
				this.AddInfo.Memo = '';
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if (this.AddInfo.OrderName == '') {
					this.$message.success("订单名称不能为空！");
					return;
				}
				let user = this.$myglobal.getUserInfo();
				this.AddInfo.OrderID = this.CommonFun.NewGuid();
				this.AddInfo.CreateDate = this.CommonFun.GetNowDateTime();
				this.AddInfo.SalerID = user.id;
				this.AddInfo.SalerName = user.username;
				this.AddInfo.OrderState = '0';
				this.AddInfo.commitcorpid = user.corpid;
				order.AddOrder(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.data.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			},
			handleDelete(index, row) {
				if (row.OrderState != '0') {
					this.$message.info('已提交过的订单不可删除哟！');
					return;
				}
				this.$confirm('确定要删掉此订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {

					order.DelOrder(row.OrderID)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.OrderList.splice(index, 1)
								//this.bao1detele = false;
								this.$message.warning("删除成功");

							} else {
								this.$message.info(ent.Msg);
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
		},
		computed: {
			data() {
				return this.OrderList.filter(item => {

					if (item.OrderName.indexOf(this.select_word) > -1) {
						return item;
					}
				});
			}
		}
	};
</script>


<style scoped>

</style>
